import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Configure axios (hybrid auth: cookies + optional Bearer)
import './api/axiosDefaults';

import { BrowserRouter } from 'react-router-dom'; // ← 追加！
import { AuthProvider } from './context/AuthContext'; // ← 追加！
import 'leaflet/dist/leaflet.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* ← 追加 */}
      <AuthProvider> {/* ← 追加 */}
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// パフォーマンス測定（ここはそのままでOK）
reportWebVitals();
